import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { storeOrdersFinance_storeOrdersFinance_edges_node } from "../../types/storeOrdersFinance";
import StoreOrdersFinanceList from "../StoreOrdersFinanceList";
import {
  createFilterStructure,
  StoreOrdersFinanceFilterKeys,
  StoreOrdersFinanceListFilterOpts
} from "./filters";

interface StoreOrdersFinanceListPageProp
  extends ListProps,
    FilterPageProps<
      StoreOrdersFinanceFilterKeys,
      StoreOrdersFinanceListFilterOpts
    >,
    TabPageProps {
  storeOrdersFinance: storeOrdersFinance_storeOrdersFinance_edges_node[];
  onBack: () => void;
  download: () => void;
}

const StoreOrdersFinanceListPage: React.FC<StoreOrdersFinanceListPageProp> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  storeOrdersFinance,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Store Orders">
          <Button
            color="primary"
            variant="contained"
            disabled={!storeOrdersFinance}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Store Order Code"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <StoreOrdersFinanceList
            storeOrdersFinance={storeOrdersFinance}
            {...listProps}
          />
        </Card>
      </Container>
    </>
  );
};

export default StoreOrdersFinanceListPage;
